// ABOUTME: React Query hooks for user profile queries and mutations
// ABOUTME: Manages fetching and updating the authenticated user's profile

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { queryKeys } from './queryKeys'

interface Profile {
  id: string
  displayName: string | null
  bodyType: string | null
  styleGoals: string | null
  colorSeason: string | null
  onboardingDone: boolean | null
  preferences: string | null
  createdAt: string
  updatedAt: string
}

export function useProfile(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.profile.all,
    queryFn: () => api.get<Profile>('/api/v1/profile'),
    enabled: options?.enabled,
  })
}

export function useUpdateProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: Partial<{
      displayName: string
      bodyType: string
      styleGoals: string[]
      colorSeason: string
      onboardingDone: boolean
      preferences: Record<string, unknown>
    }>) => api.put<Profile>('/api/v1/profile', data),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.profile.all })
    },
  })
}
